import { createMemoStyles } from '@wds/styles';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { pricingElevation } from '~app/styles/theme';
import { StyleProps } from '~pricing/components/Ribbon/types';

export default createMemoStyles(({ type, palette, packageTheme }: PricingAppTheme) => ({
  RibbonStyle: {
    fontSize: 10,
    position: 'absolute',
    height: 32,
    bottom: '100%',
    left: -2,
    right: -2,
    zIndex: pricingElevation.plusOne,
    display: 'flex',
    alignItems: 'center',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    border: ({ packageName }: StyleProps) => `2px solid ${packageTheme[packageName].primary}`,
    borderBottom: 'none !important',
    backgroundColor: palette.background.primary.medium,
    '& p': {
      fontSize: type.fontSize.body,
      fontWeight: type.fontWeight.medium,
      textAlign: 'center',
      width: '100%',
      display: 'block',
      boxShadow: 'none',
      position: 'absolute',
      margin: 0,
    },
  },
}));
